import React from 'react';

const CreateTripIcon = ({ fill = "white", className = "me-2", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" className={className} {...props}>
        <path d="M9 4.5L11.5 10L17 12.5L11.5 15L9 20.5L6.5 15L1 12.5L6.5 10L9 4.5ZM9 9.33L8 11.5L5.83 12.5L8 13.5L9 15.67L10 13.5L12.17 12.5L10 11.5L9 9.33ZM19 9.5L17.74 6.76L15 5.5L17.74 4.25L19 1.5L20.25 4.25L23 5.5L20.25 6.76L19 9.5ZM19 23.5L17.74 20.76L15 19.5L17.74 18.25L19 15.5L20.25 18.25L23 19.5L20.25 20.76L19 23.5Z" fill={fill} />
    </svg>
);

export default CreateTripIcon;